module.exports = __webpack_public_path__ + "img/1.86d49f68.png";